import React, { useState } from "react";
import useLongPress from "./../hooks/useLongPress";
import * as Const from "./../_Const";
import useScreenType from "../hooks/useScreenType";

const HiddenBackButton = ({ onClick, visible, setVisible, isClickable = true, colorTransparent = "fill-accent-dark" }) => {
  const screenType = useScreenType();

  const onLongPress = () => {
    setVisible();
    //console.log("longpress is triggered:");
  };
  const handleClick = () => {
    if (visible && isClickable) {
      //console.log("click is triggered");
      onClick();
    }
  };

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "btn":
          css = "w-[7rem]";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };
  const longPressEvent = useLongPress(onLongPress, handleClick, defaultOptions);
  const colorClass = visible ? "fill-white" : colorTransparent;
  const isTerminal = Const.isTerminal();

  return (
    <button
      {...longPressEvent}
      className={`${getCssFor("btn")} scRPIV1:w-14 scRPIV2:w-[7rem] scWaveShare:w-[7rem] tvHD:w-[6rem] tvFullHD:w-[8rem] tvFullHD:mt-2 tv4K:w-[16rem] tv4K:mt-6  flex place-content-center items-center ${colorClass}`}
    >
      {isTerminal && (
        <svg xmlns="http://www.w3.org/2000/svg" className="bg-accenta" viewBox="0 0 40 28">
          <path
            id="Icon_material-backspace"
            data-name="Icon material-backspace"
            d="M33,4.5H10.5A2.823,2.823,0,0,0,8.115,5.82L0,18,8.115,30.165A2.837,2.837,0,0,0,10.5,31.5H33a3.009,3.009,0,0,0,3-3V7.5A3.009,3.009,0,0,0,33,4.5ZM28.5,23.385,26.385,25.5,21,20.115,15.615,25.5,13.5,23.385,18.885,18,13.5,12.615,15.615,10.5,21,15.885,26.385,10.5,28.5,12.615,23.115,18Z"
            transform="translate(0 -4.5)"
          />
        </svg>
      )}
    </button>
  );
};

export default HiddenBackButton;
